var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c(
      "div",
      { staticClass: "detailContent" },
      [
        _c(
          "el-form",
          {
            ref: "formGenericContent",
            attrs: {
              "label-position": "left",
              model: _vm.formGenericContent,
              rules: _vm.formGenericContentRules
            }
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 50 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Field", prop: "field" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "Please enter",
                            maxlength: "50"
                          },
                          model: {
                            value: _vm.formGenericContent.field,
                            callback: function($$v) {
                              _vm.$set(_vm.formGenericContent, "field", $$v)
                            },
                            expression: "formGenericContent.field"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Type", prop: "type" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "Please enter",
                            maxlength: "50"
                          },
                          model: {
                            value: _vm.formGenericContent.type,
                            callback: function($$v) {
                              _vm.$set(_vm.formGenericContent, "type", $$v)
                            },
                            expression: "formGenericContent.type"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("el-divider"),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "end", gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 2 } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            _vm.centerDialogVisible = true
                          }
                        }
                      },
                      [_vm._v("Preview")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 2 } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { size: "small" },
                        on: { click: _vm.handleValidate }
                      },
                      [_vm._v("Validate")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      visible: _vm.centerDialogVisible,
                      width: "75%",
                      center: ""
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.centerDialogVisible = $event
                      }
                    }
                  },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.getContent(this.contentLang))
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.centerDialogVisible = false
                              }
                            }
                          },
                          [_vm._v("Close")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("el-divider"),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 50 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "contentEn" } },
                      [
                        _c(
                          "el-tabs",
                          {
                            staticClass: "demo-tabs",
                            attrs: { type: "border-card" },
                            on: { "tab-click": _vm.setContentLang }
                          },
                          [
                            _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "Content (EN)",
                                  "label-width": "10px"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "Please enter",
                                    type: "textarea",
                                    resize: "none",
                                    autosize: { minRows: 25, maxRows: 25 }
                                  },
                                  model: {
                                    value: _vm.formGenericContent.contentEn,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formGenericContent,
                                        "contentEn",
                                        $$v
                                      )
                                    },
                                    expression: "formGenericContent.contentEn"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-tab-pane",
                              { attrs: { label: "Content (JP)" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "Please enter",
                                    type: "textarea",
                                    resize: "none",
                                    autosize: { minRows: 25, maxRows: 25 }
                                  },
                                  model: {
                                    value: _vm.formGenericContent.contentJa,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formGenericContent,
                                        "contentJa",
                                        $$v
                                      )
                                    },
                                    expression: "formGenericContent.contentJa"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-tab-pane",
                              { attrs: { label: "Content (TC)" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "Please enter",
                                    type: "textarea",
                                    resize: "none",
                                    autosize: { minRows: 25, maxRows: 25 }
                                  },
                                  model: {
                                    value: _vm.formGenericContent.contentTc,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formGenericContent,
                                        "contentTc",
                                        $$v
                                      )
                                    },
                                    expression: "formGenericContent.contentTc"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-tab-pane",
                              { attrs: { label: "Content (SC)" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "Please enter",
                                    type: "textarea",
                                    resize: "none",
                                    autosize: { minRows: 25, maxRows: 25 }
                                  },
                                  model: {
                                    value: _vm.formGenericContent.contentSc,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formGenericContent,
                                        "contentSc",
                                        $$v
                                      )
                                    },
                                    expression: "formGenericContent.contentSc"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { attrs: { gutter: 50 } },
              [_c("el-col", { attrs: { span: 12 } })],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46e1749d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46e1749d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/genericContent/genericContentForm.vue
// module id = null
// module chunks = 